export default "__VITE_ASSET__CrONLis8__"